import { RequestDefinition } from 'front-end-core/core/Api'

import {
  METADATA,
  METADATA_PREPAY,
  METADATA_SEARCH,
  CLARILIS_LINK,
  CLARILIS_LINK_PREPAY,
  CLARILIS_DOCS,
  CLARILIS_DOCS_PREPAY,
  METADATA_SEARCH_PREPAY,
  DOC_DRAFTER_AUTOMATED_LIST,
  GET_INTERVIEW_PREVIEW,
  GET_PREVIEW_LIST,
  INTERVIEW,
  INTERVIEW_TEMPLATES,
  STATIC_DOCUMENTS,
  DOWNLOAD_INTERVIEW,
  INTERVIEW_METADATA,
  SAVED_INTERVIEW,
  DOC_DRAFTER_AUTOMATED_LIST_PREPAY,
  METADATA_SECTIONS,
  METADATA_SECTIONS_PREPAY
} from 'constants/requests'
import {
  URL_METADATA_GET_LIST,
  URL_METADATA_GET_LIST_PREPAY,
  URL_METADATA_SEARCH,
  URL_CLARILIS_LINK,
  URL_CLARILIS_LINK_PREPAY,
  URL_CLARILIS_DOCS,
  URL_CLARILIS_DOCS_PREPAY,
  URL_DOC_DRAFTER_AUTOMATED_LIST,
  URL_INTERVIEW_PREVIEW,
  URL_PREVIEW_LIST,
  URL_INTERVIEW,
  URL_INTERVIEW_TEMPLATES,
  URL_STATIC_DOCUMENTS,
  URL_DOWNLOAD_INTERVIEW,
  URL_SAVED_INTERVIEW,
  URL_INTERVIEW_METADATA,
  URL_DOC_DRAFTER_AUTOMATED_LIST_PREPAY,
  URL_METADATA_SECTIONS,
  URL_METADATA_SECTIONS_PREPAY
} from 'constants/urls'
import {
  toClarilisLink,
  toClarilisDocs,
  toMetadata,
  toMetadataSearch,
  toDocDrafterListings,
  transformPreview,
  toPreviewList,
  toDownloadedInterview
} from './transforms'
import { toSections } from 'requests/qa/transforms'

export const Metadata = new RequestDefinition({
  name: METADATA,
  url: URL_METADATA_GET_LIST,
  transform: toMetadata
})

export const MetadataPrepay = new RequestDefinition({
  name: METADATA_PREPAY,
  url: URL_METADATA_GET_LIST_PREPAY,
  transform: toMetadata
})

export const MetadataSearch = new RequestDefinition({
  name: METADATA_SEARCH,
  url: URL_METADATA_SEARCH,
  transform: toMetadataSearch
})

export const MetadataSearchPrepay = new RequestDefinition({
  name: METADATA_SEARCH_PREPAY,
  url: URL_METADATA_GET_LIST_PREPAY,
  transform: toMetadataSearch
})

export const ClarilisLink = new RequestDefinition({
  name: CLARILIS_LINK,
  url: URL_CLARILIS_LINK,
  transform: toClarilisLink
})

export const ClarilisLinkPrePay = new RequestDefinition({
  name: CLARILIS_LINK_PREPAY,
  url: URL_CLARILIS_LINK_PREPAY,
  transform: toClarilisLink
})

export const ClarilisDocs = new RequestDefinition({
  name: CLARILIS_DOCS,
  url: URL_CLARILIS_DOCS,
  transform: toClarilisDocs
})

export const ClarilisDocsPrePay = new RequestDefinition({
  name: CLARILIS_DOCS_PREPAY,
  url: URL_CLARILIS_DOCS_PREPAY,
  transform: toClarilisDocs
})

export const DocDrafterAutomatedListings = new RequestDefinition({
  name: DOC_DRAFTER_AUTOMATED_LIST,
  url: URL_DOC_DRAFTER_AUTOMATED_LIST,
  transform: toDocDrafterListings
})

export const DocDrafterAutomatedListingsPrepay = new RequestDefinition({
  name: DOC_DRAFTER_AUTOMATED_LIST_PREPAY,
  url: URL_DOC_DRAFTER_AUTOMATED_LIST_PREPAY,
  transform: toDocDrafterListings
})

export const GetInterviewPreview = new RequestDefinition({
  name: GET_INTERVIEW_PREVIEW,
  url: URL_INTERVIEW_PREVIEW,
  transform: transformPreview
})

export const GetPreviewList = new RequestDefinition({
  name: GET_PREVIEW_LIST,
  url: URL_PREVIEW_LIST,
  transform: toPreviewList
})

export const InterviewTemplates = new RequestDefinition({
  name: INTERVIEW_TEMPLATES,
  url: URL_INTERVIEW_TEMPLATES,
  transform: data => data
})

export const Interview = new RequestDefinition({
  name: INTERVIEW,
  url: URL_INTERVIEW,
  transform: data => JSON.parse(data)
})

export const StaticDocuments = new RequestDefinition({
  name: STATIC_DOCUMENTS,
  url: URL_STATIC_DOCUMENTS,
  transform: data => data
})

export const DownloadInterview = new RequestDefinition({
  name: DOWNLOAD_INTERVIEW,
  url: URL_DOWNLOAD_INTERVIEW,
  transform: toDownloadedInterview
})

export const InterviewMetdata = new RequestDefinition({
  name: INTERVIEW_METADATA,
  url: URL_INTERVIEW_METADATA,
  transform: data => JSON.parse(data)
})

export const SavedInterview = new RequestDefinition({
  name: SAVED_INTERVIEW,
  url: URL_SAVED_INTERVIEW,
  transform: data => JSON.parse(data)
})

export const PrecedentSections = new RequestDefinition({
  name: METADATA_SECTIONS,
  url: URL_METADATA_SECTIONS,
  transform: toSections
})

export const PrecedentSectionsPrepay = new RequestDefinition({
  name: METADATA_SECTIONS_PREPAY,
  url: URL_METADATA_SECTIONS_PREPAY,
  transform: toSections
})
